import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/gestorDocumental/importer/gestorDocumentalImporterActions';

export default importerReducers(actions);
